/**
 * production-lines routes. Split in two fragments so the shell keeps the
 * original registration order (index pages before the intake-scoped
 * continuations, detail pages after the calibration and reveal routes).
 */

import type { ReactNode } from 'react';
import { Navigate, Route, useParams } from 'react-router-dom';

import { ProductionLineDetailPage } from './ProductionLineDetailPage.js';
import { ProductionLineEditPage } from './ProductionLineEditPage.js';
import { ProductionLinesIndexPage } from './ProductionLinesIndexPage.js';

/** A delivered output is a video; open it where videos live. */
export function OutputRedirect(): ReactNode {
  const { productionLineId, outputId } = useParams<{
    productionLineId: string;
    outputId: string;
  }>();
  return (
    <Navigate
      to={`/videos/line/${encodeURIComponent(productionLineId ?? '')}?video=${encodeURIComponent(outputId ?? '')}`}
      replace
    />
  );
}

export const productionLinesRoutes = {
  index() {
    return (
      <>
        <Route path="/production-lines" element={<ProductionLinesIndexPage />} />
        <Route path="/production-lines/new" element={<ProductionLinesIndexPage />} />
      </>
    );
  },
  detail() {
    return (
      <>
        <Route
          path="/production-lines/:productionLineId/recommendations"
          element={<ProductionLineDetailPage />}
        />
        <Route
          path="/production-lines/:productionLineId/edit"
          element={<ProductionLineEditPage />}
        />
        <Route
          path="/production-lines/:productionLineId/outputs/:outputId"
          element={<OutputRedirect />}
        />
        <Route
          path="/production-lines/:productionLineId/:tab"
          element={<ProductionLineDetailPage />}
        />
        <Route
          path="/production-lines/:productionLineId"
          element={<ProductionLineDetailPage />}
        />
      </>
    );
  },
};
